import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite,
    madnes_add_to_group, madnes_get_alpha,
    madnes_set_alpha,
    madnes_set_angle,
    madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    server_config,
    behavior_config,
    fps,
    he,
    ico_he,
    in_free_spins,
    picture_convert,
    reels_lenghts,
    reels_pos,
    wi
} from "../framework/src/engine/madnes/madnes_variables";
import {cylinder_pos} from "./joker27plus_config";
import {madnes_anim_add, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {stopposin, stopposin_old} from "./joker27plus_core";
import {madnes_add_bitmap_text, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_fill_range, madnes_set_blend_mode} from "../framework/src/engine/madnes/madnes";
import {madnes_audio_allow_multiple, madnes_audio_loop} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_alpha_to} from "../framework/src/engine/madnes/madnes_render";

var bckground_fs_top;

// Vytvoreni potrebnych onjektu z nactenych textur.
export function joker27plus_print_desk()
{
    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    //behavior_config.reel.spin.timeToReachNullSpeed = 0;

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    // madnes_set_win_factors(
    // 	behavior_config.reel.minBigWinFactor,
    // 	behavior_config.reel.minMegaWinFactor,
    // 	behavior_config.reel.minSuperMegaWinFactor
    // );

    //madnes_add_sprite("x1", "symbol_Joker_short", 10, 10, 1);
    //madnes_add_sprite("x2", "symbol_Joker_long",  10, 200, 1);
    //madnes_add_sprite("x3", "symbol_Joker",       10, 380, 1);

    madnes_add_img("bckground", "background", 0, 0)

    madnes_add_img("freespins_reels", "freespins_reels", wi * 0.5, he * 0.5, 0, 0.5, 0.5);


    ////////////////////////////////////////////////////////////////////////////////

    var style = {
        font: "26px Arial",
        fontWeight: "bold",
        fill: "#aeab9f",
        align: "left",
        boundsAlignH: "left",
        boundsAlignV: "top",
        wordWrap: false,
        wordWrapWidth: 300
    };

    madnes_add_group("fs_center0");
    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var j in server_config.logic.reels[i])
        {

            madnes_add_sprite("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);


            madnes_anim_add("reels_bufer_" + i + "_" + j, "blur", [0]);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "stop", [1]);
            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");

            /*
            madnes_add_text("text_reels_bufer_" + i + "_" + j, cylinder_pos[i], -999, "reels_bufer_" + i + "_" + j, style);
            madnes_set_img_center("text_reels_bufer_" + i + "_" + j, -0.1, -2.5);
            */

            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];

        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        madnes_add_sprite("reels_bufer_" + i + "_S0", picture_convert[server_config.logic.failResult[i][2]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);

        madnes_add_to_group("fs_center0", "reels_bufer_" + i + "_S1");

        madnes_anim_add("reels_bufer_" + i + "_S0", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S0", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "blur", [0]);

        madnes_anim_play("reels_bufer_" + i + "_S0", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S1", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

        reels_pos[i] = 0;
    }

    madnes_add_img("dark_cover", "dark_cover", wi / 2, he / 2, 0, 0.5, 0.5);

    madnes_add_img("bckground2", "reels_cover", 0, 0);

    madnes_add_img("num_linht_r_upper_3", "light", wi - 128 - 2, 140, 1, 0.5, 0.5);
    madnes_add_img("num_linht_r_upper_2", "light", wi - 132 - 2, 184, 1, 0.5, 0.5);
    madnes_add_img("num_linht_r_upper_1", "light", wi - 134 - 2, 228, 1, 0.5, 0.5);
    madnes_add_img("num_linht_r_upper_0", "light", wi - 136 - 2, 274, 1, 0.5, 0.5);

    madnes_add_img("num_linht_r_lower_0", "light", wi - 140 - 2, 456, 1, 0.5, 0.5);
    madnes_add_img("num_linht_r_lower_1", "light", wi - 140 - 2, 500, 1, 0.5, 0.5);
    madnes_add_img("num_linht_r_lower_2", "light", wi - 136 - 2, 546, 1, 0.5, 0.5);
    madnes_add_img("num_linht_r_lower_3", "light", wi - 130 - 2, 596, 1, 0.5, 0.5);

    madnes_add_img("num_linht_l_upper_3", "light", 128, 140, 1, 0.5, 0.5);
    madnes_add_img("num_linht_l_upper_2", "light", 132, 184, 1, 0.5, 0.5);
    madnes_add_img("num_linht_l_upper_1", "light", 134, 228, 1, 0.5, 0.5);
    madnes_add_img("num_linht_l_upper_0", "light", 136, 274, 1, 0.5, 0.5);

    madnes_add_img("num_linht_l_lower_0", "light", 140, 456, 1, 0.5, 0.5);
    madnes_add_img("num_linht_l_lower_1", "light", 140, 500, 1, 0.5, 0.5);
    madnes_add_img("num_linht_l_lower_2", "light", 136, 546, 1, 0.5, 0.5);
    madnes_add_img("num_linht_l_lower_3", "light", 130, 596, 1, 0.5, 0.5);


    madnes_add_group("fs_center");
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[server_config.logic.failResult[i][2]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);

        madnes_add_to_group("fs_center", "reels_bufer_" + i + "_TMP1");

        madnes_add_bitmap_text("reels_bufer_" + i + "TEXT2", "font_win_lines", cylinder_pos[i] - 74, 120 + ico_he * 0, "100", 80);
        madnes_set_img_center("reels_bufer_" + i + "TEXT2", 0.5, 0.5);
        madnes_add_bitmap_text("reels_bufer_" + i + "TEXT1", "font_win_lines", cylinder_pos[i] - 74, 120 + ico_he * 1, "100", 80);
        madnes_set_img_center("reels_bufer_" + i + "TEXT1", 0.5, 0.5);
        madnes_add_bitmap_text("reels_bufer_" + i + "TEXT0", "font_win_lines", cylinder_pos[i] - 74, 120 + ico_he * 2, "100", 80);
        madnes_set_img_center("reels_bufer_" + i + "TEXT0", 0.5, 0.5);

        madnes_set_alpha("reels_bufer_" + i + "TEXT0", 0);
        madnes_set_alpha("reels_bufer_" + i + "TEXT1", 0);
        madnes_set_alpha("reels_bufer_" + i + "TEXT2", 0);

        madnes_add_group("x2_lines_" + i);
        madnes_add_sprite("x2_lines_flares_" + i, "x2_lines_flares", 0, 0, 1, 0.5, 0.5);
        madnes_add_to_group("x2_lines_" + i, "x2_lines_flares_" + i);

        madnes_add_sprite("x2_lines_light_off_" + i, "x2_lines_light_off", 0, 0, 1, 0.5, 0.5);
        madnes_add_to_group("x2_lines_" + i, "x2_lines_light_off_" + i);

        madnes_add_sprite("x2_lines_light_on_" + i, "x2_lines_light_on", 0, 0, 1, 0.5, 0.5);
        madnes_add_to_group("x2_lines_" + i, "x2_lines_light_on_" + i);

        madnes_set_pos("x2_lines_" + i, -9999, -9999);
    }



    madnes_add_img("logo", "reels_cover_top", wi / 2, 0, 1, 0.5, 0);

    madnes_add_group("freespins_head");
    madnes_add_img("freespins_background", "freespins_background", 0, 0, 1, 0.5, 0);
    madnes_set_scale("freespins_background", 1.18, 1);
    madnes_add_to_group("freespins_head", "freespins_background");


    madnes_add_img("freespins_counter_text", "freespins_counter_text", -120, 0, 1, 0.5, 0);
    madnes_add_to_group("freespins_head", "freespins_counter_text");

    madnes_add_bitmap_text("freespins_text", "font_free_spins", 128, -22, "0/0", 80);

    madnes_set_img_center("freespins_text", 0.5, 0);
    madnes_add_to_group("freespins_head", "freespins_text");

    madnes_set_pos("freespins_head", wi / 2, -200);

    madnes_add_group("full_screen");
    madnes_add_sprite("full_screen_background", "full_screen_background", 0, 0, 1, 0.5, 0.6);
    madnes_add_to_group("full_screen", "full_screen_background");

    madnes_add_group("full_screen_light");
    madnes_set_pos("full_screen_light", 0, -48);
    madnes_set_visible("full_screen_light", true);
    madnes_add_to_group("full_screen", "full_screen_light");

    for(var i = 0; i < 21; i++)
    {
        if(i <= 6 || i >= 15)
        {
            madnes_add_sprite("full_screen_light_" + i, "full_screen_light", 0, 0, 1, 0.5, 3.6);
        }
        else
        {
            madnes_add_sprite("full_screen_light_" + i, "full_screen_light", 0, 0, 1, 0.5, 3.5);
        }

        madnes_set_blend_mode("full_screen_light_" + i, PIXI.blendModes.ADD);
        madnes_add_to_group("full_screen_light", "full_screen_light_" + i);
    }

    madnes_set_angle("full_screen_light_0", 3);
    madnes_set_angle("full_screen_light_1", 21);
    madnes_set_angle("full_screen_light_2", 37);
    madnes_set_angle("full_screen_light_3", 53);
    madnes_set_angle("full_screen_light_4", 70);
    madnes_set_angle("full_screen_light_5", 86);
    madnes_set_angle("full_screen_light_6", 104);
    madnes_set_angle("full_screen_light_7", 122);
    madnes_set_angle("full_screen_light_8", 143);
    madnes_set_angle("full_screen_light_9", 161);
    madnes_set_angle("full_screen_light_10", 181);
    madnes_set_angle("full_screen_light_11", 199);
    madnes_set_angle("full_screen_light_12", 215);
    madnes_set_angle("full_screen_light_13", 231);
    madnes_set_angle("full_screen_light_14", 247);
    madnes_set_angle("full_screen_light_15", 264);
    madnes_set_angle("full_screen_light_16", 280);
    madnes_set_angle("full_screen_light_17", 297);
    madnes_set_angle("full_screen_light_18", 312);
    madnes_set_angle("full_screen_light_19", 328);
    madnes_set_angle("full_screen_light_20", 345);

    madnes_set_alpha("full_screen_light", 0);

    madnes_add_sprite("full_screen_x2", "full_screen_x2", 0, -48, 1, 0.5, 0.5);
    madnes_add_to_group("full_screen", "full_screen_x2");

    madnes_set_scale("full_screen_x2", 0.8, 0.8);

    madnes_set_pos("full_screen", wi * 0.5, -9999);

    madnes_add_sprite("flares_sprite", "flares_sprite", wi / 2, he / 2, 1, 0.5, 0.5);
    madnes_set_scale("flares_sprite", 4, 4);
    //madnes_add_to_group("bigwins", "flares_sprite");
    madnes_anim_add("flares_sprite", "anim", madnes_fill_range(0, 14));
    madnes_anim_add("flares_sprite", "stop", [0]);
    madnes_anim_play("flares_sprite", "stop");
    //madnes_anim_loop("flares_sprite", "anim");

    madnes_add_group("bigwins");
    madnes_set_pos("bigwins", wi * 0.5, he * 0.5);

    madnes_add_sprite("bigwins_background", "bigwins_background", 0, 0, 1, 0.5, 0.5);
    madnes_set_scale("bigwins_background", 2, 2);
    madnes_add_to_group("bigwins", "bigwins_background");

    madnes_add_group("bigwins_lights_0");
    madnes_add_group("bigwins_lights_1");

    for(var i = 0; i < 28; i++)
    {
        madnes_add_sprite("bigwins_light_" + i, "bigwins_light", 0, 0, 1, 0.5, 0.5);
        madnes_set_scale("bigwins_light_" + i, 2, 2);
        madnes_set_blend_mode("bigwins_light_" + i, PIXI.blendModes.ADD);
        madnes_add_to_group("bigwins_lights_" + ( i % 2 ), "bigwins_light_" + i);
    }

    madnes_add_to_group("bigwins", "bigwins_lights_0");
    madnes_add_to_group("bigwins", "bigwins_lights_1");

    madnes_set_alpha("bigwins_lights_0", 0);
    madnes_set_alpha("bigwins_lights_1", 0);

    madnes_set_pos("bigwins_light_0",  -328, -160);
    madnes_set_pos("bigwins_light_1",  -268, -188);
    madnes_set_pos("bigwins_light_2",  -200, -208);
    madnes_set_pos("bigwins_light_3",  -124, -224);
    madnes_set_pos("bigwins_light_4",   -46, -232);
    madnes_set_pos("bigwins_light_5",    42, -232);
    madnes_set_pos("bigwins_light_6",   120, -224);
    madnes_set_pos("bigwins_light_7",   192, -212);
    madnes_set_pos("bigwins_light_8",   266, -188);
    madnes_set_pos("bigwins_light_9",   326, -158);
    madnes_set_pos("bigwins_light_10",  326,  -96);
    madnes_set_pos("bigwins_light_11",  320,  -34);
    madnes_set_pos("bigwins_light_12",  318,   30);
    madnes_set_pos("bigwins_light_13",  320,   94);
    madnes_set_pos("bigwins_light_14",  316,  158);
    madnes_set_pos("bigwins_light_15",  252,  178);
    madnes_set_pos("bigwins_light_16",  176,  186);
    madnes_set_pos("bigwins_light_17",  106,  190);
    madnes_set_pos("bigwins_light_18",   34,  194);
    madnes_set_pos("bigwins_light_19",  -42,  194);
    madnes_set_pos("bigwins_light_20", -114,  190);
    madnes_set_pos("bigwins_light_21", -184,  184);
    madnes_set_pos("bigwins_light_22", -254,  178);
    madnes_set_pos("bigwins_light_23", -314,  158);
    madnes_set_pos("bigwins_light_24", -318,   94);
    madnes_set_pos("bigwins_light_25", -316,   30);
    madnes_set_pos("bigwins_light_26", -318,  -34);
    madnes_set_pos("bigwins_light_27", -324,  -96);


    for(var i = 0; i < 28; i++)
    {
        madnes_set_visible("bigwins_light_" + i, true);
        //madnes_set_alpha("bigwins_light_" + i, 0);
    }

    madnes_add_sprite("bigwins_text", "big_win", 0, 0, 1, 0.5, 1.0);
    madnes_set_scale("bigwins_text", 2, 2);
    madnes_add_to_group("bigwins", "bigwins_text");

    madnes_add_sprite("bigwins_foreground", "bigwins_foreground", 0, 0, 1, 0.5, 1.0);
    madnes_set_scale("bigwins_foreground", 2, 2);
    madnes_add_to_group("bigwins", "bigwins_foreground");

    madnes_add_bitmap_text("bigwins_sum", "font_bigwin", 0, 0, "0", 80);
    madnes_add_to_group("bigwins", "bigwins_sum");

    madnes_set_img_center("bigwins_sum", 0.5, -0.35);
    madnes_set_text("bigwins_sum", 100000);


    madnes_set_pos_y("flares_sprite", -9999);
    madnes_set_pos_y("bigwins", -9999);

    madnes_add_group("fs_entry_group");
    madnes_add_sprite("fs_entry_bg", "freeSpins_entry_background", 0, 0, 1, 0.5, 0.5);
    madnes_add_to_group("fs_entry_group", "fs_entry_bg");

    madnes_add_sprite("fs_entry_text", "freeSpins_entry_text", 0, 0, 1, 0.5, 0.52);
    madnes_add_to_group("fs_entry_group", "fs_entry_text");

    madnes_add_bitmap_text("fs_entry_num", "font_freeSpins_entry", 0, 0, "0", 80);
    madnes_set_img_center("fs_entry_num", 0.5, -0.6);
    madnes_add_to_group("fs_entry_group", "fs_entry_num");

    //madnes_set_pos("fs_entry_group", wi * 0.5, he * 0.5);
    madnes_set_pos("fs_entry_group", -9999, -9999);

    //bckground_fs_top = 180;

    //madnes_add_img("bckground_fs_bot", "freespins_background", wi / 2, he + bckground_fs_top, 1, 0.5, 1);

    //madnes_add_bitmap_text("bckground_fs_bot_text", "font_bigwin", wi / 2, he + bckground_fs_top, "0/0", 84);
    //madnes_set_img_center("bckground_fs_bot_text", 0.5, 2);

    joker27_lights_blink();

    madnes_audio_allow_multiple("reel_stop");

    madnes_audio_allow_multiple("win_high_with_joker");
    madnes_audio_allow_multiple("win_low_with_joker");

    madnes_audio_loop("bg_main");
}

var blink_state = "";
export function set_blink_state(state) {
    blink_state = state;
}

var blink_state_last = "";
var blink_state_wincount = 0;

function joker27_lights_blink()
{
    if(blink_state == "")
    {
        var time_to			= 80;
        var time_stay		= 200;

        if(madnes_get_alpha("num_linht_r_upper_3") == 0)
        {
            madnes_alpha_to("num_linht_r_upper_3", 1, time_to);
            madnes_alpha_to("num_linht_r_upper_2", 0, time_to);
            madnes_alpha_to("num_linht_r_upper_1", 1, time_to);
            madnes_alpha_to("num_linht_r_upper_0", 0, time_to);

            madnes_alpha_to("num_linht_l_upper_3", 1, time_to);
            madnes_alpha_to("num_linht_l_upper_2", 0, time_to);
            madnes_alpha_to("num_linht_l_upper_1", 1, time_to);
            madnes_alpha_to("num_linht_l_upper_0", 0, time_to);

            madnes_alpha_to("num_linht_r_lower_0", 1, time_to);
            madnes_alpha_to("num_linht_r_lower_1", 0, time_to);
            madnes_alpha_to("num_linht_r_lower_2", 1, time_to);
            madnes_alpha_to("num_linht_r_lower_3", 0, time_to);

            madnes_alpha_to("num_linht_l_lower_0", 1, time_to);
            madnes_alpha_to("num_linht_l_lower_1", 0, time_to);
            madnes_alpha_to("num_linht_l_lower_2", 1, time_to);
            madnes_alpha_to("num_linht_l_lower_3", 0, time_to);
        }
        else
        {
            madnes_alpha_to("num_linht_r_upper_3", 0, time_to);
            madnes_alpha_to("num_linht_r_upper_2", 1, time_to);
            madnes_alpha_to("num_linht_r_upper_1", 0, time_to);
            madnes_alpha_to("num_linht_r_upper_0", 1, time_to);

            madnes_alpha_to("num_linht_l_upper_3", 0, time_to);
            madnes_alpha_to("num_linht_l_upper_2", 1, time_to);
            madnes_alpha_to("num_linht_l_upper_1", 0, time_to);
            madnes_alpha_to("num_linht_l_upper_0", 1, time_to);

            madnes_alpha_to("num_linht_r_lower_0", 0, time_to);
            madnes_alpha_to("num_linht_r_lower_1", 1, time_to);
            madnes_alpha_to("num_linht_r_lower_2", 0, time_to);
            madnes_alpha_to("num_linht_r_lower_3", 1, time_to);

            madnes_alpha_to("num_linht_l_lower_0", 0, time_to);
            madnes_alpha_to("num_linht_l_lower_1", 1, time_to);
            madnes_alpha_to("num_linht_l_lower_2", 0, time_to);
            madnes_alpha_to("num_linht_l_lower_3", 1, time_to);
        }

        setTimeout(joker27_lights_blink, time_to * 1 + time_stay * 1);
    }
    else if(blink_state == "rotate" && !in_free_spins)
    {
        var time_to			= ( 1000 / fps ) * 5;
        var time_stay		= ( 1000 / fps ) * 1;
        var time_from		= ( 1000 / fps ) * 15;
        var time_delay		= ( 1000 / fps ) * 3.8;
        var time_delay2		= ( 1000 / fps ) * -13;
        var min_a			= 0.2;
        var max_a			= 0.8;

        var fields1 = [];
        var fields2 = [];
        fields1[fields1.length] = "num_linht_r_upper_3";
        fields1[fields1.length] = "num_linht_r_upper_2";
        fields1[fields1.length] = "num_linht_r_upper_1";
        fields1[fields1.length] = "num_linht_r_upper_0";
        fields2[fields2.length] = "num_linht_r_lower_0";
        fields2[fields2.length] = "num_linht_r_lower_1";
        fields2[fields2.length] = "num_linht_r_lower_2";
        fields2[fields2.length] = "num_linht_r_lower_3";


        for(var i in fields1)
        {
            if(blink_state_last != blink_state)
            {
                madnes_set_alpha(fields1[i], 0);
                madnes_set_alpha(fields1[i].replace("_r_", "_l_"), 0);
            }

            setTimeout(madnes_alpha_to.bind(this, fields1[i], max_a, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields1[i], min_a, time_from), time_to * 1 + time_stay * 1 + time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields1[i].replace("_r_", "_l_"), max_a, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields1[i].replace("_r_", "_l_"), min_a, time_from), time_to * 1 + time_stay * 1 + time_delay * i);
        }

        for(var i in fields2)
        {
            if(blink_state_last != blink_state)
            {
                madnes_set_alpha(fields2[i], 0);
                madnes_set_alpha(fields2[i].replace("_r_", "_l_"), 0);
            }

            setTimeout(madnes_alpha_to.bind(this, fields2[i], max_a, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields2[i], min_a, time_from), time_to * 1 + time_stay * 1 + time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields2[i].replace("_r_", "_l_"), max_a, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields2[i].replace("_r_", "_l_"), min_a, time_from), time_to * 1 + time_stay * 1 + time_delay * i);
        }

        setTimeout(joker27_lights_blink, time_from + time_delay * fields1.length + time_delay2);
    }
    else if(blink_state == "rotate" && in_free_spins)
    {
        var time_to			= ( 1000 / fps ) * 3;
        var time_stay		= ( 1000 / fps ) * 0;
        var time_from		= ( 1000 / fps ) * 3;
        var time_delay		= ( 1000 / fps ) * 2;
        var max_a			= 0.8;

        var fields = [];
        fields[fields.length] = "num_linht_r_upper_3";
        fields[fields.length] = "num_linht_r_upper_2";
        fields[fields.length] = "num_linht_r_upper_1";
        fields[fields.length] = "num_linht_r_upper_0";
        fields[fields.length] = "num_linht_r_lower_0";
        fields[fields.length] = "num_linht_r_lower_1";
        fields[fields.length] = "num_linht_r_lower_2";
        fields[fields.length] = "num_linht_r_lower_3";

        for(var i in fields)
        {
            madnes_set_alpha(fields[i], 0);
            madnes_set_alpha(fields[i].replace("_r_", "_l_"), 0);

            setTimeout(madnes_alpha_to.bind(this, fields[i], 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i], 0, time_from), time_to * 1 + time_stay * 1 + time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_"), 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_"), 0, time_from), time_to * 1 + time_stay * 1 + time_delay * i);
        }

        setTimeout(joker27_lights_blink, time_delay * fields.length);
    }
    else if(blink_state == "wincount")
    {
        var time_to			= ( 1000 / fps ) * 4;
        var time_from		= ( 1000 / fps ) * 2;
        var time_delay		= ( 1000 / fps ) * 3;
        var time_delay_end	= ( 1000 / fps ) * 6;

        var fields = [];
        fields[fields.length] = "num_linht_r_upper_0";
        fields[fields.length] = "num_linht_r_upper_1";
        fields[fields.length] = "num_linht_r_upper_2";
        fields[fields.length] = "num_linht_r_upper_3";

        for(var i in fields)
        {
            madnes_set_alpha(fields[i], 0);
            madnes_set_alpha(fields[i].replace("_r_", "_l_"), 0);
            madnes_set_alpha(fields[i].replace("_upper_", "_lower_"), 0);
            madnes_set_alpha(fields[i].replace("_r_", "_l_").replace("_upper_", "_lower_"), 0);

            setTimeout(madnes_alpha_to.bind(this, fields[i], 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_"), 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_upper_", "_lower_"), 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_").replace("_upper_", "_lower_"), 1, time_to), time_delay * i);

            setTimeout(madnes_alpha_to.bind(this, fields[i], 0, time_from), time_delay * fields.length + time_delay_end * 1);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_"), 0, time_from), time_delay * fields.length + time_delay_end * 1);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_upper_", "_lower_"), 0, time_from), time_delay * fields.length + time_delay_end * 1);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_").replace("_upper_", "_lower_"), 0, time_from), time_delay * fields.length + time_delay_end * 1);
        }

        setTimeout(joker27_lights_blink, time_delay_end * 1 + time_delay * fields.length + time_to * 1);

    }
    else if(blink_state == "moneyadd")
    {
        var time_to			= ( 1000 / fps ) * 4;
        var time_from		= ( 1000 / fps ) * 4;
        var time_delay		= ( 1000 / fps ) * 0;
        var time_delay_end	= ( 1000 / fps ) * 8;
        var time_delay_end2	= ( 1000 / fps ) * 4;

        var fields = [];
        fields[fields.length] = "num_linht_r_upper_0";
        fields[fields.length] = "num_linht_r_upper_1";
        fields[fields.length] = "num_linht_r_upper_2";
        fields[fields.length] = "num_linht_r_upper_3";

        for(var i in fields)
        {
            madnes_set_alpha(fields[i], 0);
            madnes_set_alpha(fields[i].replace("_r_", "_l_"), 0);
            madnes_set_alpha(fields[i].replace("_upper_", "_lower_"), 0);
            madnes_set_alpha(fields[i].replace("_r_", "_l_").replace("_upper_", "_lower_"), 0);

            setTimeout(madnes_alpha_to.bind(this, fields[i], 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_"), 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_upper_", "_lower_"), 1, time_to), time_delay * i);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_").replace("_upper_", "_lower_"), 1, time_to), time_delay * i);

            setTimeout(madnes_alpha_to.bind(this, fields[i], 0, time_from), time_delay * fields.length + time_delay_end * 1);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_"), 0, time_from), time_delay * fields.length + time_delay_end * 1);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_upper_", "_lower_"), 0, time_from), time_delay * fields.length + time_delay_end * 1);
            setTimeout(madnes_alpha_to.bind(this, fields[i].replace("_r_", "_l_").replace("_upper_", "_lower_"), 0, time_from), time_delay * fields.length + time_delay_end * 1);
        }

        setTimeout(joker27_lights_blink, time_delay_end * 1 + time_delay * fields.length + time_to * 1 + time_delay_end2 * 1);
    }

    blink_state_last = blink_state;
}

